import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'MinusIcon',
  'minus',
  'M153.6 499.2h716.8c28.277 0 51.2-22.923 51.2-51.2s-22.923-51.2-51.2-51.2h-716.8c-28.277 0-51.2 22.923-51.2 51.2s22.923 51.2 51.2 51.2z',
)
